import { IconProps } from "./IconProps";

export function Plus(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path d="M9.734 4v5.734H4v4.532h5.734V20h4.532v-5.734H20V9.734h-5.734V4z" />
    </svg>
  );
}
